export default (elem) => elem?.tagName === "DIALOG";
